import Media from "../components/Media";

export default function NewsPage() {
  return (
    <div data-testid="news-page">
      <Media />
    </div>
  );
}
